/* ==========================================================================
   Helpers > State
   ========================================================================== */

/* Store Constructor */
function Store(reducers = {}, initialState = {}) {
    this.subscribers = [];
    this.reducers = reducers;
    this.state = this.reduce(initialState, {});
}

/* Subscribe */
Store.prototype.subscribe = function subscribe(fn) {
    this.subscribers = [...this.subscribers, fn];
    /* Return the state passed to the subscriber on the first subscription */
    fn(this.state, {});
    return {
        unsubscribe: () => {
            this.subscribers = this.subscribers.filter(subscriber => subscriber !== fn);
        }
    };
};

/* Dispatch */
Store.prototype.dispatch = function dispatch(action) {
    this.state = this.reduce(this.state, action);
    this.subscribers.forEach(subscriber => subscriber(this.state, action));
};

/* Reduce */
Store.prototype.reduce = function reduce(state, action) {
    const newState = Object.keys(this.reducers)
        .map(key => ({ [key]: this.reducers[key](state[key], action) }))
        .reduce((acc, val) => ({ ...acc, ...val }));

    return newState;
};

/* Add reducers */
Store.prototype.addReducers = function addReducers(reducers = {}) {
    this.reducers = {
        ...this.reducers,
        ...reducers
    };
};

/* Select */
Store.prototype.select = function select(key = '') {
    return this.state[key];
};

/* Exports */
module.exports = {
    Store
};
